export default "__VITE_ASSET__B1j6_YlV__"